export function isValidShopifyAccessToken (value) {
  return /shppa_.*/.test(value)
}
